// frontend/src/site/builder/sections/ServicosForm.jsx
import React from 'react';

function Label({ children }) {
  return <div className="text-sm font-medium text-gray-800">{children}</div>;
}
function Input({ value, onChange, placeholder = '' }) {
  return (
    <input
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200"
    />
  );
}
function Textarea({ value, onChange, placeholder = '' }) {
  return (
    <textarea
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 min-h-[90px]"
    />
  );
}
function Select({ value, onChange, children }) {
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      className="mt-2 w-full px-3 py-2 rounded-lg border border-gray-200 bg-white"
    >
      {children}
    </select>
  );
}

const ICONS = [
  { id: 'home', label: 'Casa' },
  { id: 'building', label: 'Prédio' },
  { id: 'key', label: 'Chave' },
  { id: 'shield', label: 'Segurança' },
  { id: 'handshake', label: 'Negociação' },
  { id: 'chart', label: 'Investimento' },
];

export default function ServicosForm({ value = {}, onChange }) {
  const v = value || {};
  const servicos = Array.isArray(v.items) ? v.items : [];

  function patch(p) {
    onChange?.(p);
  }

  function setItem(i, p) {
    const next = [...servicos];
    next[i] = { ...(next[i] || {}), ...(p || {}) };
    patch({ items: next });
  }

  function addItem() {
    patch({
      items: [...servicos, { titulo: '', descricao: '', icon: 'home' }],
    });
  }

  function removeItem(i) {
    patch({ items: servicos.filter((_, idx) => idx !== i) });
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="md:col-span-2">
          <Label>Título</Label>
          <Input
            value={v.titulo}
            onChange={(x) => patch({ titulo: x })}
            placeholder="Ex: Serviços Especializados"
          />
        </div>

        <div className="md:col-span-2">
          <Label>Subtítulo</Label>
          <Textarea
            value={v.subtitulo}
            onChange={(x) => patch({ subtitulo: x })}
            placeholder="Ex: Ofereço uma gama completa de serviços..."
          />
        </div>
      </div>

      <div className="rounded-xl border border-gray-200 p-4">
        <div className="flex items-center justify-between">
          <div className="font-medium text-gray-900">Lista de serviços</div>
          <button
            type="button"
            onClick={addItem}
            className="px-3 py-2 rounded-lg bg-black text-white text-sm hover:opacity-90"
          >
            + Adicionar serviço
          </button>
        </div>

        <div className="mt-4 space-y-3">
          {servicos.length === 0 ? (
            <div className="text-sm text-gray-600">
              Nenhum serviço adicionado ainda.
            </div>
          ) : null}

          {servicos.map((s, i) => (
            <div key={i} className="rounded-xl border border-gray-200 p-3">
              <div className="flex items-center justify-between gap-2">
                <div className="text-sm font-semibold text-gray-900">
                  Serviço #{i + 1}
                </div>
                <button
                  type="button"
                  onClick={() => removeItem(i)}
                  className="px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 text-sm"
                >
                  Remover
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
                <div>
                  <Label>Ícone</Label>
                  <Select
                    value={s.icon || 'home'}
                    onChange={(x) => setItem(i, { icon: x })}
                  >
                    {ICONS.map((it) => (
                      <option key={it.id} value={it.id}>
                        {it.label}
                      </option>
                    ))}
                  </Select>
                </div>

                <div className="md:col-span-2">
                  <Label>Título</Label>
                  <Input
                    value={s.titulo}
                    onChange={(x) => setItem(i, { titulo: x })}
                    placeholder="Ex: Compra de Imóveis"
                  />
                </div>

                <div className="md:col-span-3">
                  <Label>Descrição</Label>
                  <Textarea
                    value={s.descricao}
                    onChange={(x) => setItem(i, { descricao: x })}
                    placeholder="Ex: Encontro o imóvel ideal com análise completa..."
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="text-xs text-gray-500">
        (Depois conectamos os ícones reais no render público; aqui é só o “id”.)
      </div>
    </div>
  );
}
